import React, { ReactNode } from 'react'
import styled from 'styled-components';

const DropdownToggle = styled.div`
   font-size: inherit;
`;

interface DropdownLaunchProps {
  setDropDownOpen?: (b: boolean) => void;
  isDropdownOpen?: boolean;
  children: ReactNode;
  showDropdown?: any;
  dropdownOpen?: any;
}

const DropdownLaunch = ({ setDropDownOpen, isDropdownOpen, children, showDropdown, dropdownOpen }: DropdownLaunchProps) => {
  return (
    <DropdownToggle onClick={(e) => { showDropdown!(!dropdownOpen!) }
    }>
      {children}
    </DropdownToggle>
  )
}

export default DropdownLaunch
